module.exports = __webpack_public_path__ + "img/banner-golau.639f07fd.jpg";